// We have havascript
document.documentElement.classList.remove("no-js");

// Picture element HTML5 shiv
document.createElement( "picture" );

// IE detection object
theme.oldBrowsers = {
    isIE11: (!!window.MSInputMethodContext && !!document.documentMode),
    isIE10Down: (window.navigator.userAgent.indexOf('MSIE') > 1) ? true : false
}

// Add a class for targeting for ie11
if (theme.oldBrowsers.isIE11) {
    document.documentElement.classList.add("ie11");
}

/**
 *
 * IE 11 polyfills
 *
 */
if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down) {

    // Picture element support
    document.createElement( "picture" );

    // Establish which polyfills we need
    var polyfills = [
        'https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.min.js',
    ];

    // Loop through each polyfil and write it to the document
    for (var i = 0; i < polyfills.length; i++) {
        let polyfill = document.createElement('script');
        polyfill.src = polyfills[i];
        polyfill.async = true;
        document.getElementsByTagName('head')[0].appendChild(polyfill)
    }

}